import { Tab } from "bootstrap";
import { ApiService } from "../../02_utils/apiService";
import { Logger } from "../../02_utils/logger";
import { Utils } from "../../02_utils/utils";
import { FilterInputService } from "../filter/Services/filterInputService";
import { LoaderService } from "../filter/Services/loaderService";
import { PaginationService } from "../filter/Services/paginationService";
import { RenderService } from "../filter/Services/renderService";
import { RequestService } from "../filter/Services/requestService";
import { IFilters, ISearchModel, ISearchRequest, SearchRequest } from "./dto/requestBody.dto";
import { SearchRequestService } from "./Services/searchRequestService";
import { SearchInputService } from "./Services/serachInputService";


export class Search {
  private search: HTMLElement;
  private searchRequestSerivce: SearchRequestService;
  private searchInputService: SearchInputService;
  private loaderService: LoaderService;
  private filters: Array<IFilters> = new Array();
  private tabs: HTMLElement;
  private totals: NodeListOf<HTMLElement>;
  private notFound: NodeListOf<HTMLElement>;
  private activateTabOnNextResponse = false;

  constructor(searchElement: HTMLElement, private $log: Logger, private $utils: Utils, private $apiService: ApiService) {
    this.search = searchElement;
    this.tabs = this.search.querySelector('.js-tabs');
    this.totals = this.search.querySelectorAll('[data-total]');
    this.notFound = this.search.querySelectorAll('[data-not-found]');
    const documentId = parseInt(this.search.dataset.document ?? '');
    this.searchInputService = new SearchInputService(this.search, this.$log, this.$utils, this.$apiService);

    this.mapFilters();

    this.searchRequestSerivce = new SearchRequestService(this.search, this.filters, this.$log, this.$utils, this.$apiService);
    this.searchRequestSerivce.requestBody.document = documentId;

    this.filters?.forEach(filter => {
      this.searchRequestSerivce.requestBody.filterDefinitions.push({
        id: filter.id,
        key: filter.key,
      });

      this.searchRequestSerivce.requestBody.nextPage[filter.key] = 1;

      filter.filterRequestService.requestBody.subscribe((requestBody) => {
        filter.renderService.requestBody = requestBody;
        this.searchRequestSerivce.requestBody.fields[filter.key] = requestBody.fields;
      });

      filter.paginationService.page.subscribe(page => {
        this.searchRequestSerivce.requestBody.nextPage[filter.key] = page;
        filter.renderService.currentPage = page;
        this.searchRequestSerivce.loadNextPage();
      });
    });

    this.searchInputService.requestBody = this.searchRequestSerivce.requestBody;

    this.searchInputService.filters.subscribe(filters => {
      this.$utils.addOrRemoveClases('add', 'd-none', this.notFound);
      this.searchInputService.updateFilters();
      this.filters.forEach(filter => {
        filter.paginationService.page.next(1);
      });
      this.searchRequestSerivce.requestBody.filters = filters;

      if (this.filtersEmpty(filters) && !this.search.dataset.degree) {
        this.$utils.addOrRemoveClases('add', 'd-none', this.tabs);
      } else {
        this.$utils.addOrRemoveClases('remove', 'd-none', this.tabs);

        this.activateTabOnNextResponse = true;

        this.searchRequestSerivce.loadNextPage();
      }
    });

    if (this.searchInputService.setInitFiltersFromUrl()) {
      this.searchInputService.updateFilters();
    }

    this.searchRequestSerivce.dataModel.subscribe((dataModel) => {

      if (Object.values(dataModel).filter(model => model && model.pagination.totalCount != 0).length == 0) {
        this.$utils.addOrRemoveClases('add', 'd-none', this.tabs);
        this.$utils.addOrRemoveClases('remove', 'd-none', this.notFound);
        return;
      }

      this.filters?.forEach(filter => {
        const filterDataModel = dataModel[filter.key];
        this.updateTotal(dataModel);
        filter.paginationService.pagination = dataModel[filter.key].pagination;
        filter.paginationService.updatePagination();

        filter.renderService.render(filterDataModel);
      });

      if (this.activateTabOnNextResponse) {
        this.activateTab(dataModel);
        this.activateTabOnNextResponse = false;
      }
    });
  }

  private updateTotal(dataModel: ISearchModel) {
    this.totals?.forEach((total) => {
      const key = total.dataset.key;
      const totalCount = dataModel[key]?.pagination?.totalCount;

      if (totalCount == 0) {
        (total.parentElement as HTMLButtonElement).disabled = true;
      } else {
        (total.parentElement as HTMLButtonElement).disabled = false;
      }

      total.innerHTML = totalCount?.toString();
    });
  }

  private activateTab(dataModel: ISearchModel) {
    const filter = this.filters.find(a  => dataModel[a.key].pagination.totalCount != 0) ?? null;
    const triggerEl = this.search.querySelector(`button[data-bs-target="#${filter?.key}"]`);
    if (triggerEl) {
      const tab = Tab.getOrCreateInstance(triggerEl);
      tab?.show();
    }
  }

  private filtersEmpty(filters: {[key: string]: any}): boolean {
    let empty = true;

    Object.values(filters).forEach(filter => {
      if (filter) {
        empty = false;
      }
    });

    return empty;
  }

  private mapFilters() {
    const filters: NodeListOf<HTMLElement> = this.search.querySelectorAll('.js-search-filter');
    filters?.forEach(filter => {
      const key = filter.dataset.key;
      const id = parseInt(filter.dataset.filterDefinition);
      const filterRequestService = new RequestService(filter, this.$log, this.$utils, this.$apiService, this.loaderService, this.searchInputService);
      const renderService = new RenderService(filter, this.$log, this.$utils);
      const loaderService = new LoaderService(filter, this.$log, this.$utils, renderService);
      const paginationService = new PaginationService(filter, this.$log, this.$utils);

      this.filters.push({
        element: filter,
        key: key,
        id: id,
        renderService: renderService,
        loaderService: loaderService,
        paginationService: paginationService,
        filterRequestService: filterRequestService,
      });
    });

  }
}
